import { Component, OnInit, signal } from '@angular/core';
import { Router } from '@angular/router';
import { USER_MGMT_CNST } from '../../../../constants/proj.cnst';
import { isNullOrUndefined } from '../../../../modules/shared';
import { AppStateService } from '../../../../services/app-state.service';
import { EnvService } from '../../../../services/env.service';
import { HttpService } from '../../../../services/http.service';
import { UtilsService } from '../../../../services/utils.service';
import { MessageService } from 'primeng/api';
import { ImportsModule } from '../../../../modules/imports/imports';
import { SkeletonModule } from '../../../../modules/shared/components/skeleton/skeleton.module';
import { PrimengBreadcrumbComponent } from '../../../../modules/shared/components/primeng-breadcrumb/primeng-breadcrumb.component';
import { CustomDatePipe } from '../../../../pipes/custom-date.pipe';

@Component({
  selector: 'app-assign-resource',
  templateUrl: './assign-resource.component.html',
  standalone : true,
  imports : [
    ImportsModule,
    SkeletonModule,
    PrimengBreadcrumbComponent,
    CustomDatePipe
  ],
  providers :[]
})
export class AssignResourceComponent implements OnInit {
  customerTableData: any[] = [];
  rolesTableData: any[] = [];
  active: any;
  isCustomerSubmitButtonEnabled: boolean = false;
  isRoleSubmitButtonEnabled: boolean = false;
  customerResourceAllocationMap: any = {};
  customerResourceAllocationMapCopy: any = {};
  roleResourceAllocationMap: any = {};
  roleResourceAllocationMapCopy: any = {};
  userPermission: any;
  isCustomer: boolean = false;
  isUserCustomerServiceExecutive: boolean = false;
  loggedInUserTypes = USER_MGMT_CNST.LOGGED_IN_USER_TYPES;
  isSuperAdmin: boolean = false;
  isDisabled: boolean = false;
  loading = signal(true);
  applicationData: any;
  listOfCustomers: any;
  customerTableDataCopy: any[] = [];
  rolesTableDataCopy: any[] = [];

  constructor(
    private appStateSrv: AppStateService,
    private router: Router,
    private httpSrv: HttpService,
    private utilsSrv: UtilsService,
    private messageService: MessageService,
    private envService: EnvService) { }



  ngOnInit() {
    if (this.appStateSrv.getLoggedInUserType() === this.loggedInUserTypes.superAdmin) {
      this.isSuperAdmin = true;
    }
    // let metaInfo = this.appStateSrv.getUserMetaInfo();
    let  metaInfo : any =  localStorage.getItem("metaInfo")
    metaInfo = JSON.parse(metaInfo);
    this.isCustomer = !!(metaInfo && (metaInfo['customerId'] || metaInfo['customerName']));
    this.applicationData = this.appStateSrv.getApplicationData();
    // CSE - Customer Service Executive
    // Can only add and update users on behalf of customer admin for a customer
    // Only read access on other resources
    this.isUserCustomerServiceExecutive = this.checkIfUserIsCSE();
    if (!this.applicationData) {
      this.router.navigate(['usermgmt', 'applications']);
    }
    if (this.applicationData) {
      this.loadData();
    }
  }

  async loadData() {
    let customerApiStatus = await this.fetchListOfCustomers();
    if (!isNullOrUndefined(customerApiStatus)) {
      this.fetchListOfRoles();
    }
  }
  fetchListOfCustomers(): Promise<boolean> {
    this.loading.set(true);
    return new Promise((resolve) => {
      this.httpSrv
        .makeGetApiCall('GET_CUSTOMERS_LIST', this.envService.baseUrl, {
          uriParams: {
            applicationId: this.applicationData.info.applicationId,
            resourceActionId: this.applicationData.info.resourceActionId,
          },
        })
        .subscribe({
          next: (response: any) => {
            this.customerTableData = response;
            this.customerTableDataCopy = response;
            this.initializeCustomerResourceAllocationMap();
            resolve(true);
          },
          error: (err: any) => {
            this.loading.set(false)
            this.utilsSrv.showToastMessage('Failed to fetch customer list', 'error');
            resolve(false);
          },
        });
    });
  }

  fetchListOfRoles() {
    this.loading.set(true);
    this.httpSrv
      .makeGetApiCall('LIST_OF_PROFILES', this.envService.baseUrl, {
        uriParams: {
          applicationId: this.applicationData.info.applicationId,
          resourceActionId: this.applicationData.info.resourceActionId
        }
      })
      .subscribe({
        next: (response: any) => {
          this.rolesTableData = response['response'];
          this.rolesTableDataCopy = response['response'];
          this.initializeRoleResourceAllocationMap();
        },
        complete:()=>{
          this.loading.set(false);
        },
        error: (err: any) => {
          this.loading.set(false);
          this.utilsSrv.showToastMessage('Failed to fetch customer list', 'error');
        }
      });
  }

  initializeCustomerResourceAllocationMap() {
    this.customerTableData.forEach((customerInfo: any) => {
      let { customerId, assigned } = customerInfo;
      this.customerResourceAllocationMap[customerId] = assigned;
    })
    this.customerResourceAllocationMapCopy = { ...this.customerResourceAllocationMap };
  }

  initializeRoleResourceAllocationMap() {
    this.rolesTableData.forEach((roleInfo: any) => {
      let { roleId, isAssigned } = roleInfo;
      this.roleResourceAllocationMap[roleId] = isAssigned;
    })
    this.roleResourceAllocationMapCopy = { ...this.roleResourceAllocationMap };
  }

  toggleCustomerResourceAllocationMap(customerId: string) {
    this.customerResourceAllocationMap[customerId] = !this.customerResourceAllocationMap[customerId];
    this.isCustomerSubmitButtonEnabled = this.enableOrDisableSubmitButton('customer');
  }

  toggleRoleResourceAllocationMap(roleId: string) {
    this.roleResourceAllocationMap[roleId] = !this.roleResourceAllocationMap[roleId];
    this.isRoleSubmitButtonEnabled = this.enableOrDisableSubmitButton('role');
  }

  buildLabel(id: number) {
    return `flexCheckChecked${id}`;
  }

  enableOrDisableSubmitButton(type: string): boolean {
    let entityCopy = type === 'customer'
      ? this.customerResourceAllocationMapCopy
      : this.roleResourceAllocationMapCopy;
    let entity = type === 'customer'
      ? this.customerResourceAllocationMap
      : this.roleResourceAllocationMap;
    for (let id in entityCopy) {
      let existingStatus = entityCopy[id];
      let currentStatus = entity[id];
      if ((existingStatus === true && currentStatus === false) ||
        (existingStatus === false && currentStatus === true)) {
        return true;
      }
    }
    return false;
  }

  submitCustomers() {
    this.isDisabled = true;
    let postData: {
      resourceActionId: any,
      assignedCustomers: any[],
      unAssignedCustomers: any[]
    } = {
      resourceActionId: this.applicationData.info.resourceActionId,
      assignedCustomers: [],
      unAssignedCustomers: []
    }
    for (let customerId in this.customerResourceAllocationMapCopy) {
      // false - true (assign)
      // true - false (unassign)
      let existingStatus = this.customerResourceAllocationMapCopy[customerId];
      let currentStatus = this.customerResourceAllocationMap[customerId];

      if (existingStatus === true && currentStatus === false) {
        postData.unAssignedCustomers.push(customerId);
      } else if (existingStatus === false && currentStatus === true) {
        postData.assignedCustomers.push(customerId);
      }
    }
    this.httpSrv
      .makePostApiCall('ASSIGN_RESOURCE_TO_CUSTOMERS', postData, this.envService.baseUrl)
      .subscribe({
        next: (response: any) => {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Resources Updated Successfully'
          });
          this.fetchListOfCustomers();
          this.isDisabled = false;
        },
        error: (err: any) => {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Failed to Update the Resources'
          });
          this.isDisabled = false;
        }
      });

  }

  submitRoles() {
    this.isDisabled = true;
    let postData: {
      resourceActionId: any,
      assignedRoleIds: any[],
      unAssignedRoleIds: any[]
    } = {
      resourceActionId: this.applicationData.info.resourceActionId,
      assignedRoleIds: [],
      unAssignedRoleIds: []
    }
    for (let roleId in this.roleResourceAllocationMapCopy) {
      // false - true (assign)
      // true - false (unassign)
      let existingStatus = this.roleResourceAllocationMapCopy[roleId];
      let currentStatus = this.roleResourceAllocationMap[roleId];

      if (existingStatus === true && currentStatus === false) {
        postData.unAssignedRoleIds.push(roleId);
      } else if (existingStatus === false && currentStatus === true) {
        postData.assignedRoleIds.push(roleId);
      }
    }

    this.httpSrv
      .makePostApiCall('ASSIGN_RESOURCE_TO_ROLES', postData, this.envService.baseUrl)
      .subscribe({
        next: (response: any) => {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Resources Updated Successfully'
          });
          this.fetchListOfRoles();
          this.isDisabled = false;
        },
        error: (err: any) => {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Failed to Update the Resources'
          });
          this.isDisabled = false;
        }
      });
  }

  navigateToApplicationsList() {
    this.router.navigate(['usermgmt', 'applications']);
  }

  onCustomerSelect(e: any) {
    if (!isNullOrUndefined(e)) {
      const customerIds: any[] = [];
      for (let customer of e) {
        customerIds.push(customer.customerId);
      }
      this.customerTableDataCopy = this.customerTableData.filter(x => customerIds.includes(x.customerId));
    }
  }

  clearCustomerOptions() {
    this.customerTableDataCopy = this.customerTableData;
  }

  onRoleSelect(e: any) {
    if (!isNullOrUndefined(e)) {
      const roleIds: any[] = [];
      for (let role of e) {
        roleIds.push(role.roleId);
      }
      this.rolesTableDataCopy = this.rolesTableData.filter(x => roleIds.includes(x.roleId));
    }
  }

  clearRoleOptions() {
    this.rolesTableDataCopy = this.rolesTableData;
  }

  // Return true / false based on if logged in user
  // has role of customer service executive
  checkIfUserIsCSE(): boolean {
    let userPermissions = this.appStateSrv.getUserPermissions();
    if (this.utilsSrv.isObjectNotNullAndEmpty(userPermissions)) {
      let appName = Object.keys(userPermissions)[0];
      if (!isNullOrUndefined(appName)) {
        let appPermissions = userPermissions[appName];
        if (this.utilsSrv.isObjectNotNullAndEmpty(appPermissions)) {
          let { roleName = null } = appPermissions;
          if (!isNullOrUndefined(roleName)) {
            return roleName === USER_MGMT_CNST.CUSTOMER_SERVICE_EXECUTIVE;
          }
        }
      }
    }
    return false;
  }
}
